<template>
  <div id="chatMessageContainer" :class="isAdmin ? 'admin':''">
    <chatMessage />
    <chatAdminInputArea v-if="isAdmin" />
    <chatInputArea />
    <contextMenu />
    <chatMessageSetting />
    <chatMessageCheerSetting />
    <div id="popupLayout">
      <div id="popupLayoutInner"></div>
    </div>
  </div>
</template>

<script>
import chatMessage from './chat-message'
import chatInputArea from './chat-input'
import chatAdminInputArea from './chat-inputAdmin'
import contextMenu from './chat-contextMenu'
import chatMessageSetting from './chat-message-setting-menu'
import chatMessageCheerSetting from './chat-message-cheer-setting'
import * as Cookies from 'js-cookie'

export default {
  data: function () {
    return {
      'isAdmin': window.is_admin
    }
  },
  components: {
    'chatMessage': chatMessage,
    'chatInputArea': chatInputArea,
    'chatAdminInputArea': chatAdminInputArea,
    'contextMenu': contextMenu,
    'chatMessageSetting': chatMessageSetting,
    chatMessageCheerSetting
  },
  mounted: function () {
    this.$nextTick(() => {
      let screen = document.getElementById('chatMessageList')
      if (screen) {
        screen.scrollTop = screen.scrollHeight
        let fontSize = 12
        let lineHeight = 13
        if (Cookies.get('font_size') && Cookies.get('line_size')){
          fontSize = Cookies.get('font_size')
          lineHeight = Cookies.get('line_size')
        } else {
          Cookies.set('font_size', fontSize + '')
          Cookies.set('line_size', lineHeight + '')
        }
        screen.style.setProperty('font-size', fontSize + 'px', 'important')
        screen.style.setProperty('line-height', lineHeight + 'px', 'important')
      }
    })
  }
}
</script>

<style lang="scss">
:focus {
  outline-color: transparent;
  outline-style: none;
}
#chatMessageContainer {
  width: 100%;
  height: calc(100% - 120px);
  padding: 69px 0 0;
  &.admin {
    height: calc(100% - 150px);
  }
}
#popupLayout {
  position: absolute;
  bottom: 32px;
  background-color: rgba(0,0,0,0.65);
  width: 100%;
  text-align: center;
  padding: 5px 0;
  display: none;
}
#popupLayoutInner {
  p {
    margin-top: 8px;
    letter-spacing: -1px;
    color: #fff;
    font-size: 12px;
  }
  .btn_area {
    margin-top: 10px;
    text-align: center;
    font-size: 0;
    line-height: 0;
    a {
      display: inline-block;
      height: 29px;
      text-indent: -9000px;
      overflow: hidden;
      background: url(/nlivechat/img/sprites.png) no-repeat -590px -60px;
    }
    .btn_ok {
      width: 68px;
      margin-right: 1px;
      background-position: 0 -190px;
    }
    .btn_no {
      width: 83px;
      background-position: -80px -190px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// chat-message-container.vue?ec1ada9a